export default [
    {
        path : '/thirdAuth',
        name : 'thirdAuth',
        component : resolve => {
            require(['components/thirdOrg/thirdAuth.vue'], resolve);
        },
        meta : {
            // login : true,
            title : '三方授权'
        }
    },
    {
        path : '/authedThirdOrg',
        name : 'authedThirdOrg',
        component : resolve => {
            require(['components/thirdOrg/thirdOrgDetail.vue'], resolve);
        },
        meta : {
            // login : true,
            title : '小区授权'
        }
    },
    // {
    //     path : '/orgAuthHistory',
    //     name : 'orgAuthHistory',
    //     component : resolve => {
    //         require(['components/thirdOrg/orgAuthHistory.vue'], resolve);
    //     },
    //     meta : {
    //         // login : true,
    //         title : '查看小区授权'
    //     }
    // }






]



// WEBPACK FOOTER //
// ./src/router/routers/thirdorg.js